var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68668 6.31333L6.31334 9.68667C5.88001 9.25333 5.61334 8.66 5.61334 8C5.61334 6.68 6.68001 5.61333 8.00001 5.61333C8.66001 5.61333 9.25334 5.88 9.68668 6.31333Z",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 3.84667C10.7134 2.96667 9.38002 2.48667 8.00002 2.48667C5.64668 2.48667 3.45335 3.87333 1.92668 6.27333C1.32668 7.21333 1.32668 8.79334 1.92668 9.73334C2.45335 10.56 3.06668 11.2733 3.73335 11.8467",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61334 13.02C6.37334 13.34 7.18001 13.5133 8.00001 13.5133C10.3533 13.5133 12.5467 12.1267 14.0733 9.72667C14.6733 8.78667 14.6733 7.20667 14.0733 6.26667C13.8533 5.92 13.6133 5.59333 13.3667 5.28667",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.34 8.46667C10.1667 9.40667 9.40002 10.1733 8.46002 10.3467",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31331 9.68667L1.33331 14.6667",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 1.33333L9.68665 6.31333",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.627d03175d5401d08e7ca08529666064.svg";
export { ForwardRef as ReactComponent };